import { render, staticRenderFns } from "./CanvasToolbarTopPreviewButtonsEditModal.vue?vue&type=template&id=d3f98ca2"
import script from "./CanvasToolbarTopPreviewButtonsEditModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./CanvasToolbarTopPreviewButtonsEditModal.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports